export const SeenReferralTooltipCompanyIdsLocalStorageKey = 'seenReferralTooltipCompanyIds'
